<template>
    <nav class="navbar navbar-expand-lg navbar-light shadow-sm">
        <div class="container">
            <router-link class="navbar-brand" to="/scans/">EASY</router-link>
            <button class="btn btn-primary rounded-circle" @click="logout">
                <i class="fa-solid fa-right-from-bracket"></i>
            </button>
        </div>
    </nav>

    <router-view />
</template>

<script>
export default {
    name: 'AppLayout',
    setup() {
        const logout = async () => {
            // Clear the authentication token
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');

            // Redirect to the login page
            window.location.href = '/'
        }

        return { logout };
    }
};
</script>
